import { getLocale } from "@tami/core";

/**
 * "2025-03-14" → "março de 2025".
 *
 * A data é fixada ao meio-dia UTC e formatada em UTC de propósito: `new
 * Date("2025-03-01")` é meia-noite UTC, e num fuso negativo como o do Brasil
 * isso vira 28/02 local — o card passaria a exibir o mês errado.
 */
export const formatMemberSince = (isoDate: string | null): string | null => {
  if (!isoDate) {
    return null;
  }

  const date = new Date(`${isoDate.slice(0, 10)}T12:00:00Z`);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  // Criado a cada chamada: no escopo do módulo congelaria o idioma.
  return new Intl.DateTimeFormat(getLocale(), {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
};
